
import img1 from "../../assets/images/ser1.svg";
import img2 from "../../assets/images/ser2.svg";
import img3 from "../../assets/images/ser3.svg";
import img4 from "../../assets/images/ser4.svg";
import img5 from "../../assets/images/ser5.svg";
import img6 from "../../assets/images/ser6.svg";
import img7 from "../../assets/images/cricalRight.svg";
import img8 from "../../assets/images/ser7.svg";
import img9 from "../../assets/images/ser8.svg";
import img10 from "../../assets/images/ser9.svg";
import img11 from "../../assets/images/ser10.svg";

export const cardList = [
    {
   h3:"Complete Integration",
   p:"Full integration with PTM Travel services for seamless travel booking and management",
   img:img1
},
    {
   h3:"Wallet Integration",
   p:"Seamless integration with your application's existing wallet system for transactions",
   img:img2
},
    {
   h3:"React Native Support",
   p:"Built specifically for React Native with full iOS and Android support",
   img:img3
},
    {
   h3:"Secure Transactions",
   p:"Enterprise-grade security for all financial transactions",
   img:img4
},
    {
   h3:"Easy Setup",
   p:"Simple installation and configuration process with CLI support",
   img:img5
},
    {
   h3:"Comprehensive Docs",
   p:"Detailed documentation with examples and best practices",
   img:img6
},
]
export const cardList2 = [
    {
   h3:"Quick plug and play installation",
   img:img7
},
    {
   h3:"Offline-first capabilities",
   img:img7
},
    {
   h3:"Built-in error handling",
   img:img7
},
    {
   h3:"Optimized data management",
   img:img7
},
    {
   h3:"Pre-built UI components",
   img:img7
},

]
export const cardList3 = [
    {
   h3:"Travel startups",
   img:img8
},
    {
   h3:"OTA platforms",
   img:img9
},
    {
   h3:"Corporate travel tools",
   img:img10
},
    {
   h3:"Super apps & lifestyle apps",
   img:img11
},
  
 

];




export const cardList4 = [
    {
   h3:"Faster Time to Market",
   p:"Launch your travel app or service in days, not months. Our SDK does the heavy lifting so your team can focus on the user experience.",
   img:img7
},
    {
   h3:"Plug-and-Play Integration",
   p:"Just drop in the SDK and get access to all travel features — no need to write complex code or connect multiple APIs.",
   img:img7
},
    {
   h3:"Reduced Development Costs",
   p:"Save on backend engineering, design, and infrastructure. Everything is pre-integrated and production-ready.",
   img:img7
},
    {
   h3:"Built-in UI/UX",
   p:"Get modern, user-friendly interfaces out of the box — customizable to match your brand.",
   img:img7
},
    {
   h3:"Scalable & Secure",
   p:"Our SDK is built to handle high-volume traffic, secure transactions, and real-time updates with minimal effort on your part.",
   img:img7
},
    {
   h3:"Ongoing Support & Updates",
   p:"We continuously update the SDK with new features, bug fixes, and enhancements — keeping your app ahead of the curve.",
   img:img7
},
]